export default "__VITE_ASSET__edee4b44__"